import React from "react";
import OurKegs from '../../assets/home/our-kegs.png'
import KegToTap from '../../assets/home/from-keg-to-tap.png'
// import KegFirst from '../../assets/home/keg1.svg'
// import KegSecond from '../../assets/home/keg2.svg'
// import KegThird from '../../assets/home/keg3.svg'
import KegFirst from '../../assets/new-home-png/keg1.png'
import KegSecond from '../../assets/new-home-png/keg2.png'
import KegThird from '../../assets/new-home-png/keg3.png'
import { useTranslation } from "react-i18next";
import { 
    Background, 
    SustainabilityHeader,
    SustainabilityTittleUpText,
    SustainabilityText,
    SustainabilityTittle,
    SustainabilityTittleDiv,
    RowWrapper,
    TapsImage,
    SustainabilityBottomLine
} from "./styles";

const Sustainability = () => {
    const { t } = useTranslation();

    return(
        <Background>
            <SustainabilityHeader>
                <div>
                    <h1>{t("sustainability")}</h1>
                    <p>{t("sourceWinesCocktails")}</p>
                    <p>{t("carslbergEnvironmental")}</p>
                </div>
            </SustainabilityHeader>
            <SustainabilityTittleDiv>
                <SustainabilityTittleUpText></SustainabilityTittleUpText>
                {/* <SustainabilityTittleUpText>{t("troubleshooting")}</SustainabilityTittleUpText> */}
                <SustainabilityTittle src={OurKegs}/>
            </SustainabilityTittleDiv>
            <RowWrapper>
                <TapsImage src={KegFirst}/>
                <TapsImage src={KegSecond}/>
            </RowWrapper>
            <SustainabilityTittleDiv>
                <SustainabilityTittle src={KegToTap} smaller/>
                <SustainabilityText>{t("systemsUsedByBeer")}</SustainabilityText>
            </SustainabilityTittleDiv>
            <RowWrapper center>
                <TapsImage src={KegThird} solo/>
            </RowWrapper>
            <SustainabilityBottomLine/>
        </Background>
    )
}
export default Sustainability;
